import defaultAvatar from "../../assets/logo/logo.png";
import { API_BASE_URL } from "../../services/api";
import "../../styles/modal.css";

export default function AdminDetailsModal({ admin, onClose }) {
  if (!admin) return null;

  const avatar = admin.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${admin.profilPicture}`
    : defaultAvatar;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modalHeader">
          <img src={avatar} alt="avatar" className="modalAvatar" />

          <div>
            <div className="modalName">
              {admin.firstName} {admin.lastName}
            </div>
            <div className="modalRole">
              {admin.role?.name || "Administrateur"}
            </div>
          </div>

          <button className="modalClose" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* BODY */}
<div className="modalSection">
  <h4 className="modalSectionTitle">Informations générales</h4>

  <div className="modalGrid">
    <Info label="Username" value={admin.username} />
    <Info label="Rôle" value={admin.role?.name || "Administrateur"} />
  </div>
</div>

<div className="modalSection">
  <h4 className="modalSectionTitle">Contact</h4>

  <div className="modalGrid">
    <Info label="Téléphone" value={admin.contact?.tel} />
    <Info label="Email" value={admin.contact?.email} />
    <Info label="WhatsApp" value={admin.contact?.whatsapp} />
    <Info label="Adresse" value={admin.contact?.adress} />
  </div>
</div>

      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="infoItem">
      <span className="infoLabel">{label}</span>
      <span className="infoValue">{value || "-"}</span>
    </div>
  );
}
